<template>
  <div v-if="currentOffer">
    <section class="section--colored">
      <v-container>
      <v-row>
        <v-col 
        :cols="$vuetify.breakpoint.smAndDown ? 12 : 8">
          <div class="d-flex justify-center align-center" >
            <v-img
              :height="$vuetify.breakpoint.smAndDown ? 300 : 600"
              :src="currentOffer.posterUrl"
              :lazy-src="currentOffer.posterLazyUrl"
            ></v-img>
          </div>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 4" >
          <div class="d-flex flex-column justify-space-between" style="height:100%">
            <div style="height:160px">
              <v-img
                height="100%"
                :src="currentOffer.logoUrl"
                :lazy-src="currentOffer.logoLazyUrl"
                contain
              ></v-img>
            </div>

            <div class="text-center font-weight-light text-price">
              {{ currentOffer.price }} €
            </div>

            <div class="text-left my-8" v-html="currentOffer.description"></div>

            <v-btn rounded depressed color="#ef6758" style="color:white" x-large :to="{path: `/mon-projet/${currentOffer.iso}`}">
              Acheter {{ currentOffer.title }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      </v-container>
    </section>

    <section 
    v-if="currentOffer.howItWorksSteps.length > 0"
    class="section">
      <CcmGeneric 
      :title="currentOffer.howItWorksTitle"
      :steps="currentOffer.howItWorksSteps"
      :example-title="currentOffer.exampleTitle"
      :example-link="currentOffer.exampleLink"/>
    </section>

    <section 
    v-if="currentOffer.deliverySteps.length > 0" 
    class="section section--colored">
      <DeliveryGeneric
      :title="currentOffer.deliveryTitle"
      :steps="currentOffer.deliverySteps" />
    </section>

    <section class="section text-center">
      <h2 class="ccm-title">
        {{ currentOffer.after.title }}
      </h2>
      <div style="max-width:600px" class="mx-auto">
        <p v-html="currentOffer.after.description"></p>
        <p>
          <v-row align="center" justify="center" class="my-6">
            <v-btn color="#ef6758" style="color:white" rounded x-large link :href="`/mon-projet/${currentOffer.iso}`">
              {{ currentOffer.after.moreAction }}
            </v-btn>
          </v-row>
        </p>
      </div>
    </section>

    <section v-if="currentOffer.whySteps.length > 0" class="section section--colored">
      <DeliveryGeneric
      :title="currentOffer.whyTitle"
      :steps="currentOffer.whySteps" />
    </section>

    <section class="section">
      <v-row align="center" justify="center" class="my-8">
        <v-btn color="#ef6758" style="color:white" x-large rounded link :href="`/mon-projet/${currentOffer.iso}`">
          Acheter {{ currentOffer.title }}
        </v-btn>
      </v-row>
      <v-row align="center" justify="center" class="my-6">
        <v-btn color="#ef6758" style="color:white" small rounded link href="/nos-offres">
          Voir les autres offres
        </v-btn>
      </v-row>
      <p style="max-width:600px" class="text-center mx-auto">
        Vous souhaitez plus d'informations ?
        <br/>
        <router-link to="/contact" class="no-deco">
          Contactez-nous !
        </router-link>
      </p>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CcmGeneric from '../components/home/CcmGeneric.vue'
import DeliveryGeneric from '../components/home/DeliveryGeneric.vue'

export default {
  components: { CcmGeneric, DeliveryGeneric },
  methods: {
    ...mapActions('strapiv2', ['setCurrentOffer'])
  },
  computed: {
    ...mapGetters('strapiv2', ['currentOffer'])
  },
  mounted () {
    const iso = this.$route.params.iso
    this.setCurrentOffer(iso)
  }
}
</script>

<style scoped>
.text-price {
  font-size: 3em;
  font-weight: 300;
}

.no-deco {
  color:black;
  text-decoration: none;
}
</style>